import * as React from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import * as moment from 'moment';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box } from '@src/components';

// typing
interface LocalState extends State {
    next: any;
}

// style
const style = css`
    h4 {
        font-size: 24px;
        text-align: center;
    }
    ${mixin.row}
    > .chart {
    }
    > .peaks {

        > article {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding: 20px;
            margin-bottom: 10px;
            background: #f1f3f4;
            border: 1px solid #ccc;

            &:first-of-type {
                > span > i {
                    background-color: ${vars.colors.red};
                }
            }
            &:last-of-type {
                > span > i {
                    background-color: ${vars.colors.blue};
                }
            }
            > span {
                ${mixin.iconBadge}
                color: ${vars.colors.white};
            }
            > div {
                padding-left: ${vars.gutter}px;
                > span {
                    display: block;
                    font-size: 24px;
                }
                > strong {
                    font-size: 30px;
                }
            }
        }
    }
`;

// component
export class Temp extends Proto<Props, LocalState> {
    state = {
        startDate: moment().subtract(14, 'days'),
        // startDate: moment('2018-01-01'),
        endDate: moment()
    } as LocalState;

    async componentWillMount() {
        this.loadWithFilters(this.state);
    }
    
	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { data } = this.state;

        const config = {
            ...this.TempGraphProps(),
        };

		const toolbar = () => (
            <DateRangePicker {...this.DatePickerProps()} />
        );
        
        let min, max;
        if (data.meta) {
            min = data.meta.mintemp;
            max = data.meta.maxtemp;
        }

		return (
            <Box
                title={_('temp_title', 'BatteryLife')}
                toolbar={toolbar}
                collapsed={false}
                nodata={(data.data.length === 0)}
            >
                <div className={style}>
                    <section className="chart">
                        <h4>{_('temp_title', 'BatteryLife')}</h4>
                        <AmCharts.React style={{ width: "100%", height: "400px" }} options={config} />
                    </section>
                    <section className="peaks">
                        <h4>{_('temp_title_peak', 'BatteryLife')}</h4>
                        {min &&
                        <article>
                            <span>
                                <i className="fa fa-thermometer-4" />
                            </span>
                            <div>
                                <span>{_('temp_max', 'BatteryLife')}</span>
                                <strong>{max} °C</strong>
                            </div>
                        </article>
                        }
                        {max &&
                        <article>
                            <span>
                                <i className="fa fa-thermometer-1" />
                            </span>
                            <div>
                                <span>{_('temp_min', 'BatteryLife')}</span>
                                <strong>{min} °C</strong>
                            </div>
                        </article>
                        }
                    </section>
                </div>
            </Box>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/BatteryLife/Temp.tsx